module.exports = __webpack_public_path__ + "img/BatInduV.0473b6a4.png";